import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

const GefaessdiagnostikPage = () => {
  return (
    <Layout>
      <PageHero
        title="Gefäßdiagnostik"
        subtitle="Abklärung von Durchblutungsstörungen an Arterien und Venen."
        backgroundImage="/images/Gelenke.webp"
        ctaText="Termin buchen"
      />

      <ContentSection
        title="Wann ist eine Gefäßuntersuchung sinnvoll?"
        content="Bei Beinschmerzen beim Gehen, kalten Füßen, Krampfadern oder bekannten Gefäßerkrankungen kann eine Gefäßuntersuchung Aufschluss über die Durchblutungssituation geben."
        image="/images/Gelenke.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Moderne Ultraschall-Diagnostik"
        content="Wir untersuchen Arterien und Venen mit schonenden Ultraschallverfahren zur frühzeitigen Erkennung von Durchblutungsstörungen. Die Untersuchung ist schmerzfrei und ohne Strahlenbelastung."
        image="/images/2B4_Ultraschall.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="Gefäßdiagnostik Diez"
        content="PAVK-Diagnostik und Gefäßultraschall im Medicum Diez zur sicheren Abklärung von Arterien- und Venenerkrankungen im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Gefäßuntersuchung vereinbaren"
        subtitle="Vereinbaren Sie Ihren Termin zur Gefäßdiagnostik online oder telefonisch."
        buttonText="Termin buchen"
      />
    </Layout>
  );
};

export default GefaessdiagnostikPage;
